import type { AppToastType } from "./showAppToast";

export function getToastTypeForHttpStatus(status: number): AppToastType {
  if (status === 429) return "rateLimitError";
  if (status === 503) return "searchError";
  return "error";
}
